import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
type Notice = {
  name: string;
  country: string;
  minutesAgo: number;
  key: number;
};
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1 + Math.floor(Math.random() * 3);
      setNotice({
        ...buyer,
        minutesAgo: 1 + Math.floor(Math.random() * 9),
        key: Date.now()
      });
      hideTimer = window.setTimeout(() => setNotice(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-39" data-mp="1fxmzdr8b00fd">
      <AnimatePresence data-id="element-40" data-mp="n6leraludcog">
        {notice && !dismissed && <motion.div key={notice.key} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_18px_40px_-12px_rgba(5,15,36,0.45)] ring-1 ring-navy-900/10" data-id="element-41" data-mp="n97p1i04a6ad">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain p-1" data-id="element-42" data-mp="23kv52a9n9bhx" />
            <div className="min-w-0" data-id="element-43" data-mp="2fmv3ay3kbutm">
              <p className="text-sm leading-snug text-ink" data-id="element-44" data-mp="2fltezrxjdbty">
                <span className="font-bold" data-id="element-45" data-mp="2kmhhb9r7tf3h">{notice.name}</span> from{" "}
                <span className="font-bold" data-id="element-46" data-mp="2plu45ui36m62">{notice.country}</span> just purchased the digital Blueprint
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-medium text-success" data-id="element-47" data-mp="1ryv0gzsz8dyo">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="1wwn58uepzuka" />
                Verified purchase · {notice.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Dismiss notifications" data-id="element-49" data-mp="26mzkq87ogxjk">
              <XIcon className="h-4 w-4" data-id="element-50" data-mp="3rfncpmsuncq3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}